import { marked } from "marked";
import {
  addLineBreaksAroundImages,
  normalizeLatexToDoubleDollar,
} from "./fileHelpers";
import { formatLatexInHtmlTags } from "../../../../../../../../utils/PreProcessorLatexCode";

/**
 * Same markdown/LaTeX pipeline as `GenerateAllLessonEditorPlugin` (without Lexical).
 * Used to persist lesson/assignment HTML before optional editor insert.
 */
export function markdownAnswerToHtml(rawAnswer) {
  if (rawAnswer == null || rawAnswer === "") return "";

  const addNewLine = addLineBreaksAroundImages(String(rawAnswer));
  const preprocessedText = normalizeLatexToDoubleDollar(addNewLine);
  const sections = preprocessedText?.split(/\$\$/) || [];

  const processedSections = sections.map((section, index) => {
    if (index % 2 === 1) {
      if (!section || section.trim() === "") {
        return "";
      }
      const escapedSection = section
        .replace(/</g, " \\lt ")
        .replace(/>/g, " \\gt ");
      return `<p>$$${escapedSection}$$</p>`;
    }
    return marked(section);
  });

  const last_chatHist = processedSections.join("");
  const finalAnswer = last_chatHist
    .replace("<STARTOFTURN>", "")
    .replace("<ENDOFTURN>", "");

  const mergedContent = finalAnswer
    .replace(
      /<\/p>\s*<span>(\$\$[^$]*?\$\$)<\/span>\s*<p>/gi,
      (match, latexContent) => `</p><p><span>${latexContent}</span>`,
    )
    .replace(
      /<\/p>\s*<span>(\$\$[^$]*?\$\$)<\/span>\s*(<h[1-6]|<\/h[1-6]|<ul|<\/ul|<ol|<\/ol)/gi,
      (match, latexContent, nextTag) =>
        `<p><span>${latexContent}</span></p>${nextTag}`,
    )
    .replace(
      /(<\/h[1-6]|<\/ul|<\/ol)\s*<span>(\$\$[^$]*?\$\$)<\/span>\s*<p>/gi,
      (match, closingTag, latexContent) =>
        `${closingTag}<p><span>${latexContent}</span></p><p>`,
    )
    .replace(
      /<\/p>\s*<span>(\$\$[^$]*?\$\$)<\/span>\s*<\/p>/gi,
      (match, latexContent) => `<p><span>${latexContent}</span></p>`,
    );

  return formatLatexInHtmlTags(mergedContent);
}
